// import { NoEncryption } from "@mui/icons-material"

export const MentionsInputStyle = {
  control: {
    // backgroundColor: '#000',
    backgroundColor: "none",
    border: "none",
    outline: "none",
    //   fontSize: 14,
    //   fontWeight: 'normal',
  },

  "&multiLine": {
    control: {
      // fontFamily: 'monospace',
      minHeight: 32,
      "&focus": {
        border: "none",
        outline: "none",
        boxShadow: "none",
      },
    },
    highlighter: {
      padding: 3,
      border: "1px solid transparent",
      // backgroundColor: '#1E1E1E',
      "&focus": {
        border: "none",
        outline: "none",
        boxShadow: "none",
      },
    },
    input: {
      padding: 3,
      color: "#FFF",
      "&focus": {
        border: "none",
        outline: "none !important",
        outlineWidth: "0 !important",
        boxShadow: "none",
        "-moz-box-shadow": "none",
        "-webkit-box-shadow": "none",
      },
      "&selected": {
        border: "none",
        outline: "none",
      },

      // border: '1px solid silver',
    },
  },

  "&singleLine": {
    control: {
      // backgroundColor: '#000',
      // backgroundColor: "#1A1A1A",
      border: "none",
      outline: "none",
      // '&hover': {
      //   border: "1px solid green",
      // }
      // alignItems: "center",
      // display: "flex",
    },

    display: "inline-block",
    width: "100%",

    highlighter: {
      // paddingTop: 4,
      padding: 1,
      border: "2px inset transparent",
      // backgroundColor: '#1A1A1A',
      backgroundColor: "transparent",
    },
    input: {
      padding: 3,
      border: "none",
      outline: "none",
      color: "var(--text-color-secondary)",
      // color: "#FFD600",

      // '&focus': {
      //   border: '2px solid pink',
      //   outline: 'none',
      //   boxShadow: 'none',
      // },
      // '&selected': {
      //   border: '2px solid yellow',
      //   outline: 'none',
      //   boxShadow: 'none',
      // },
      // '&hover': {
      //   border: '2px solid green',
      //   outline: 'none',
      //   boxShadow: 'none',
      // },
    },
  },

  suggestions: {
    list: {
      backgroundColor: "var(--autocomplete-background)",
      fontSize: 14,
    },
    item: {
      padding: "5px 15px",
      // borderBottom: '1px solid rgba(0,0,0,0.15)',
      "&focused": {
        backgroundColor: "var(--autocomplete-highlight)",
      },
    },
  },

  // suggestions: {
  //   list: {
  //     backgroundColor: '#1E1E1E',
  //     fontSize: 14,
  //   },
  //   item: {
  //     padding: '5px 15px',
  //     borderBottom: '1px solid rgba(0,0,0,0.15)',
  //     '&focused': {
  //       backgroundColor: '#FFD600',
  //     },
  //   },
  // },
};

export const MentionStyle = {
  backgroundColor: "#FFD600",
  // backgroundColor: '#1d232d',

  opacity: "0.5",
};
